interface PageHeroProps {
  title: string;
}

export function PageHero({ title }: PageHeroProps) {
  return (
    <div className="bg-primary pt-24 pb-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl md:text-4xl font-medium text-white text-center">
          {title}
        </h1>
        <div className="h-1 w-16 bg-secondary mt-3 mx-auto"></div>
      </div>
    </div>
  );
}